import React, { useEffect, useState } from 'react'
import FetchApi from '../../../customhooks/functionFetchApi';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaFileSignature } from 'react-icons/fa';

const PopUpCheckList = ({ tdsCode }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [journals, setJournals] = useState([]);

    useEffect(() => {
        const fetchApi = new FetchApi();
        const getlistjournal = async () => {
            setLoading(true);
            try {
                const res = await fetchApi.FethcGet(`/quarity/GettdsCheckQuarityBytdscode/${tdsCode}`);
                if (res?.status === 200) {
                    setJournals(res.data.data);
                } else {
                    setJournals([]);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setJournals([]);
            } finally {
                setLoading(false);
            }
        };

        if (show && tdsCode) {
            getlistjournal();
        }
    }, [show, tdsCode]);

    const renderItem = (item, index) => {
        const statusColor = item?.StatusName === 'ยังไม่ผ่านการตรวจสอบ' ? 'text-danger' : 'text-success';

        return (
            <li key={item?.id ?? index} className="list-group-item py-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="fw-semibold">{item?.tdscode || `TDS ${index + 1}`}</div>
                    <span className={`fw-semibold ${statusColor}`}>{item?.StatusName || '-'}</span>
                </div>
                <div className="mb-2">
                    <div><span className="text-secondary">ผู้ยืนยัน:</span> {item?.userConfirm || '-'}</div>
                    <div><span className="text-secondary">กลุ่มสินค้า:</span> {item?.productGroup || '-'}</div>
                    <div><span className=" fw-semibold text-primary">แผนก:</span> {item?.departName || '-'}</div>
                    <div><span className="text-secondary">เวลาบันทึก:</span> {item?.stampdate || '-'}</div>
                     <div><span className="text-secondary">note:</span> {item?.remark || '-'}</div>
                </div>
            </li>
        );
    };

    const renderBody = () => {
        if (loading) {
            return (
                <div className="d-flex justify-content-center py-4">
                    <Spinner animation="border" role="status" />
                </div>
            );
        }

        if (!journals.length) {
            return <div className="text-center text-muted py-3">ไม่พบข้อมูลรายการตรวจสอบ</div>;
        }

        return (
            <div className="list-group list-group-flush">
                {journals.map(renderItem)}
            </div>
        );
    };

    return (
        <>
            <Button variant="secondary" size="sm" onClick={() => setShow(true)} style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                รอตรวจ QA/RD
            </Button>

            <Modal show={show} onHide={() => setShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FaFileSignature className="me-2" /> รายการตรวจสอบ QA/RD
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>{renderBody()}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        ปิด
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PopUpCheckList
